export default __webpack_public_path__ + "static/media/menuBars.a01726aa.svg";